import React from 'react';

import {
  VirtualizedList,
  Stack,
  makeStyles,
  Typography,
} from '@gogame/components';
import { DateValueFormatter } from '@gogame/intl-ts';

import * as Links from './Links';
import SourceBadge from './SourceBadge';

export const getLinkComponent = (feature) => {
  switch (feature) {
    case 'ManualSpending':
    case 'CostAdjustment':
    case 'SpendAdjustment':
      return Links.SpendAdjustmentsLink;
    case 'FinancialResult':
      return Links.FinancialResultsLink;
    case 'IOManagement':
      return Links.IoManagementLink;
    case 'Gallery':
      return Links.GalleryLink;
    case 'BusinessPartner':
      return Links.BusinessPartnerLink;
    case 'PromoCodes':
      return Links.PromoCodesLink;
    default:
      /* eslint-disable-next-line */
      console.log(`Unknown feature: ${feature}`);
      return Links.EmptyLink;
  }
};

const types = {
  FR: 'Financial result',
  MS: 'Manual spend',
  CA: 'Cost adjusment',
  IO: 'IO management',
  GL: 'Gallery',
  SA: 'Spend Adjustment',
  BP: 'Business Partner',
  PC: 'Promo Codes',
};

const useStyles = makeStyles((theme) => {
  return {
    listItem: {
      '&.hovered': {
        background: theme.palette.action.hover,
      },
    },
    root: {
      height: '100%',
      '& ::-webkit-scrollbar-track': {
        borderLeft: `1px solid ${theme.palette.divider}`,
      },
    },
    actions: {
      flex: 1,
      padding: '16px',
    },
    message: {
      textDecoration: 'none',
    },
  };
});

const NotificationsList = ({ data, onReadMessage }) => {
  const classes = useStyles();

  return (
    <Stack direction={'column'} className={classes.root}>
      <VirtualizedList
        className={classes.listItem}
        data={data?.list || []}
        rowHeight={72}
        labelWrap={false}
        getOptionLabel={({ type, feature, message, relatedActionId }) => {
          const NotificationLink = getLinkComponent(feature);
          return (
            <NotificationLink
              className={classes.message}
              type={type}
              relatedActionId={relatedActionId}
            >
              <Typography variant={'body1'} lineClamp={2}>
                {message}
              </Typography>
            </NotificationLink>
          );
        }}
        getOptionSecondaryLabel={({ date, source }) => {
          return (
            <Stack spacing={1} direction={'row'} alignItems={'center'}>
              <Typography variant={'overline'} display={'block'}>
                {types[source] || 'Unknown:' + source}
              </Typography>
              <Typography>|</Typography>
              <Typography variant={'overline'} display={'block'}>
                <DateValueFormatter
                  value={date}
                  template={'LLL'}
                  timeZone={'local'}
                />
              </Typography>
            </Stack>
          );
        }}
        icon={({ source, isRead, id }) =>
          source ? (
            <SourceBadge
              type={source}
              isRead={isRead}
              onClick={() => {
                onReadMessage(id);
              }}
            />
          ) : null
        }
      />
    </Stack>
  );
};

export default NotificationsList;
